import type { ScreenParameters, SpecificNavigationProp } from 'app/types/navigation';
import type { Loan } from 'app/types/loan';
import type { Listing } from 'app/types/listing';
import type { ParamListBase } from '@react-navigation/routers';
import { navigationRef } from 'app/lib/root-navigation';

export function navigateToLoan<T extends keyof ScreenParameters>(
  navigation: SpecificNavigationProp<T>,
  loanId: Loan['id'],
  listingId: Listing['id'],
) {
  navigation.navigate('one-loan', { id: loanId, listingId }, { pop: true });
}

export function navigateInCurrentNavigatorWithFallback<T extends keyof ScreenParameters>(
  navigation: SpecificNavigationProp<T>,
  screen: T,
  fallbackTab: 'management' | 'billboard' | 'notifications' | 'profile',
  params?: ParamListBase[T],
  closeCurrentOnFallback?: boolean,
) {
  if (navigation.getState().routeNames.includes(screen)) {
    navigation.navigate(screen as any, params, { pop: true });
    return;
  }

  if (closeCurrentOnFallback) {
    navigation.goBack();
  }
  setTimeout(() => {
    navigation.navigate(fallbackTab as any, { screen, params, initial: false });
  }, 10);
}

export function navigateToPaymentSuccess() {
  if (!navigationRef.isReady()) return;
  navigationRef.navigate('payment-success');
}

export function navigateToMyPlan() {
  if (!navigationRef.isReady()) return;
  navigationRef.navigate('main', {
    screen: 'profile',
    params: { screen: 'my-plan', initial: false },
    initial: false,
  });
}
